module.exports = __webpack_public_path__ + "static/media/social-media-marketing.1f00fb06.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/social-media-marketing.svg
// module id = 318
// module chunks = 0